/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { hoverTransition, aniSpeed } from '../../../utils/styles/general';



/* ++++++++++ --------------- INDICATOR - CONTENT SCROLLER : STYLES --------------- ++++++++++ */
export default {
    indicator: {
        
    }
};
